const StrToNum = (str) => {
    const num = parseInt(str.replace(/\s/g, ""));
    return num;
}

export default StrToNum;